import { useEffect } from 'react';

const useScrollRestore = (key: string) => {
  useEffect(() => {
    const pos = Number(sessionStorage.getItem(key) || 0);
    if (pos) setTimeout(() => window.scrollTo(0, pos), 0);
    return () => {
      sessionStorage.setItem(key, String(window.scrollY));
    };
  }, [key]);
};

export default useScrollRestore;


